import React from 'react';

const theme = '#5e4aee';

const InstagramLogo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path
        fill={theme}
        d="M51.05,16.27H23.11a4.36,4.36,0,0,0-4.36,4.35v28a4.36,4.36,0,0,0,4.36,4.35H51.05a4.36,4.36,0,0,0,4.36-4.35v-28A4.36,4.36,0,0,0,51.05,16.27ZM45.1,22a1.14,1.14,0,0,1,1.14-1.14h3.44A1.15,1.15,0,0,1,50.83,22v3.44a1.16,1.16,0,0,1-1.15,1.15H46.24a1.15,1.15,0,0,1-1.14-1.15Zm-8,5.61a7,7,0,1,1-7,7A7,7,0,0,1,37.12,27.61ZM52,48.35a1.14,1.14,0,0,1-1.14,1.15H23.33a1.15,1.15,0,0,1-1.15-1.15V31.17h4.59a7,7,0,0,0-.8,3.48,11.15,11.15,0,0,0,22.3,0,5.85,5.85,0,0,0-.88-3.48H52Z"
      />
    </svg>
  );
};

export default InstagramLogo;
